import { Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { UserService, AuthService } from '@app/core/services';
import { AccountService } from '@app/core/services/Common/account.service';
import { Permission } from '@app/shared/models/Authentication/permission.model';
import { AppService, IndividualTenantArr, Tenant } from '@app/shared/models/Common/enums';
import { slideToggle } from '@app/composables/slideToggle.js';
import { slideUp } from '@app/composables/slideUp.js';
import { AppSettings } from '@app/services/app-settings.service';
import { Subscription } from 'rxjs';
import { MenuUpdateService } from '@app/core/services/Common/menu-update.service';



@Component({
  providers: [AuthService],
  selector: 'sa-navigation',
  templateUrl: './navigation.component.html'

})
export class NavigationComponent implements OnInit, OnDestroy {
  @ViewChild('sidebarScrollbar', { static: false }) private sidebarScrollbar: ElementRef;
  @Output() calculateFloatSubMenuPosition = new EventEmitter();
  @Output() appSidebarMinifiedToggled = new EventEmitter<boolean>();
  @Output() appSidebarMobileToggled = new EventEmitter<boolean>();

  @Output() hideMobileSidebar = new EventEmitter<boolean>();
  @Output() setPageFloatSubMenu = new EventEmitter();
  private menuUpdateSubscription: Subscription;

  @Input() appSidebarTransparent;
  @Input() appSidebarGrid;
  @Input() appSidebarFixed;
  @Input() appSidebarMinified;

  appSidebarFloatSubMenu;
  appSidebarFloatSubMenuHide;
  appSidebarFloatSubMenuHideTime = 250;
  appSidebarFloatSubMenuTop;
  appSidebarFloatSubMenuLeft = '60px';
  appSidebarFloatSubMenuRight;
  appSidebarFloatSubMenuBottom;
  appSidebarFloatSubMenuArrowTop;
  appSidebarFloatSubMenuArrowBottom;
  appSidebarFloatSubMenuLineTop;
  appSidebarFloatSubMenuLineBottom;
  appSidebarFloatSubMenuOffset;

  mobileMode;
  desktopMode;
  scrollTop;


  private user: any;
  hasHealthRights: boolean = false;
  hasLifeRights: boolean = false;
  userTenantCode: string;
  tenantId: number = 0;

  private subscription!: Subscription;

  constructor(private authService: AuthService,
    private menuUpdateService: MenuUpdateService,
    public appSettings: AppSettings, private acountService: AccountService) {
    this.user = this.authService.currentUser;

    this.setupMenu();

  }
  menus: any[];
  ngOnInit() {
    this.menuUpdateSubscription = this.menuUpdateService.menuUpdate$.subscribe(() => {
      this.getAppMenus();
    });
  }

  setupMenu() {

    this.hasHealthRights = this.authService.hasHealthAccess;
    this.hasLifeRights = this.authService.hasLifeAccess;
    this.userTenantCode = this.authService.tenantCode;
    this.tenantId = this.authService.tenantId;
    this.getAppMenus();
  }
  ngAfterViewChecked() {
    if (typeof (Storage) !== 'undefined' && localStorage.sidebarScroll) {
      if (this.sidebarScrollbar && this.sidebarScrollbar.nativeElement) {
        this.sidebarScrollbar.nativeElement.scrollTop = localStorage.sidebarScroll;
      }
    }
  }

  @HostListener('scroll', ['$event'])
  onScroll(event) {
    this.scrollTop = (false) ? event.srcElement.scrollTop + 40 : 0;
    if (typeof (Storage) !== 'undefined') {
      localStorage.setItem('sidebarScroll', event.srcElement.scrollTop);
    }
  }

  calculateAppSidebarFloatSubMenuPosition() {
    var targetTop = this.appSidebarFloatSubMenuOffset.top;
    var direction = document.body.style.direction;
    var windowHeight = window.innerHeight;

    setTimeout(() => {
      let targetElm = <HTMLElement>document.querySelector('.app-sidebar-float-submenu-container');
      let targetSidebar = <HTMLElement>document.getElementById('sidebar');
      // var targetHeight = targetElm == null ? 0 : targetElm.offsetHeight;
      var targetHeight = targetElm.offsetHeight;
      this.appSidebarFloatSubMenuRight = 'auto';
      this.appSidebarFloatSubMenuLeft = (this.appSidebarFloatSubMenuOffset.width + targetSidebar.offsetLeft) + 'px';

      if ((windowHeight - targetTop) > targetHeight) {
        this.appSidebarFloatSubMenuTop = this.appSidebarFloatSubMenuOffset.top + 'px';
        this.appSidebarFloatSubMenuBottom = 'auto';
        this.appSidebarFloatSubMenuArrowTop = '20px';
        this.appSidebarFloatSubMenuArrowBottom = 'auto';
        this.appSidebarFloatSubMenuLineTop = '20px';
        this.appSidebarFloatSubMenuLineBottom = 'auto';
      } else {
        this.appSidebarFloatSubMenuTop = 'auto';
        this.appSidebarFloatSubMenuBottom = '0';

        var arrowBottom = (windowHeight - targetTop) - 21;
        this.appSidebarFloatSubMenuArrowTop = 'auto';
        this.appSidebarFloatSubMenuArrowBottom = arrowBottom + 'px';
        this.appSidebarFloatSubMenuLineTop = '20px';
        this.appSidebarFloatSubMenuLineBottom = arrowBottom + 'px';
      }
    }, 0);
  }
  showAppSidebarFloatSubMenu(menu, e) {
    if (this.appSettings.appSidebarMinified) {
      clearTimeout(this.appSidebarFloatSubMenuHide);
      this.appSidebarFloatSubMenu = menu;
      this.appSidebarFloatSubMenuOffset = e.target.getBoundingClientRect();
      this.calculateAppSidebarFloatSubMenuPosition();
    }
  }
  remainAppSidebarFloatSubMenu() {
    clearTimeout(this.appSidebarFloatSubMenuHide);
  }


  hideAppSidebarFloatSubMenu() {
    this.appSidebarFloatSubMenuHide = setTimeout(() => {
      this.appSidebarFloatSubMenu = '';
    }, this.appSidebarFloatSubMenuHideTime);
  }

  expandCollapseSubmenu(e, currentMenu, allMenu, active = false) {
    e.preventDefault();
    var targetItem = (e.target).closest('.menu-item');
    var target = <HTMLElement>targetItem.querySelector('.menu-submenu');
    slideToggle(target);
    this.calculateFloatSubMenuPosition.emit();

  }
  toggleAppSidebarMobile() {
    this.appSidebarMobileToggled.emit(true);
  }
  toggleAppSidebarMinified() {
    this.appSidebarMinifiedToggled.emit(true);
    this.scrollTop = 40;
  }
  getAppMenus() {
    var mennusArr = [];
    var dashbaordArr = {
      'index': 1,
      'icon': 'fa fa-home',
      'title': 'Dashboard',
      'url': '/Dashboard',
      'mode': '',
      'submenu': [],
      'caret': 'true',
    };
    var CompArr = {
      'icon': 'fa fa-file-archive-o',
      'title': 'Comparator Test',
      'url': '/test/comparator',
      'mode': '',
      'submenu': []
    };

    if (this.hasHealthRights) {
      var QuotationHealthArr = {
        'index': 2,
        'icon': 'fa fa-plus',
        'title': 'Health',
        'url': '#',
        'mode': '',
        'caret': 'true',
        'submenu': []
      };

      dashbaordArr.submenu.push(
        {
          'icon': 'fa fa-plus',
          'url': '/health/dashboard',
          'mode': '',
          'title': 'Group Health'
        }
      );
      if (this.hasGroupQuotationRights) {

        QuotationHealthArr.submenu.push(
          {
            'icon': 'fa fa-sticky-note',
            'url': '/quote/health/' + this.userTenantCode,
            'mode': 'NEW',
            'title': 'Group Quote'
          }
        );
      }

      if (this.hasHealthIndividualQuotationRights && IndividualTenantArr.indexOf(this.tenantId) > -1) {
        QuotationHealthArr.submenu.push(
          {
            'icon': 'fa fa-sticky-note',
            'url': '/quote/indhealth/' + this.userTenantCode,
            'mode': 'NEW',
            'title': 'Individual Quote'
          }
        );
      }
      QuotationHealthArr.submenu.push(
        {
          'icon': 'fa fa-database',
          'url': '/health/listing/quotes',
          'mode': '',
          'title': 'Quotation Listing'
        }
      );
      if (this.hasHealthApprovalRights) {
        QuotationHealthArr.submenu.push(
          {
            'icon': 'fa fa-rocket',
            'url': '/health/listing/approval',
            'mode': '',
            'title': 'My Approval'
          }
        );
      }
      QuotationHealthArr.submenu.push(
        {
          'icon': 'fa fa-pencil-square',
          'url': '/health/listing/draft',
          'mode': '',
          'title': 'My Draft'
        }
      );
      mennusArr.push(QuotationHealthArr);

    }

    if (this.hasLifeRights) {
      dashbaordArr.submenu.push(
        {
          'icon': 'fa fa-heartbeat',
          'url': '/life/dashboard',
          'mode': '',
          'title': 'Group Life'
        }
      );
      var QuotationLifeArr = {
        'index': 3,
        'icon': 'fa fa-heartbeat',
        'title': 'Life',
        'url': '#',
        'mode': '',
        'caret': 'true',
        'submenu': []
      };
      QuotationLifeArr.submenu.push(
        {
          'icon': 'fa fa-sticky-note',
          'url': '/quote/life/' + this.userTenantCode,
          'mode': 'NEW',
          'title': 'New Quotation'

        }
      );
      QuotationLifeArr.submenu.push(
        {
          'icon': 'fa fa-database',
          'url': '/life/listing/quotes',
          'mode': '',
          'title': 'Quotation Listing'
        }
      );
      if (this.hasLifeApprovalRights) {
        QuotationLifeArr.submenu.push(
          {
            'icon': 'fa fa-rocket',
            'url': '/life/listing/approval',
            'mode': '',
            'title': 'My Approval'
          }
        );
      }
      QuotationLifeArr.submenu.push(
        {
          'icon': 'fa fa-pencil-square',
          'url': '/life/listing/draft',
          'mode': '',
          'title': 'My Draft'
        }
      );
      mennusArr.push(QuotationLifeArr);

    }
    mennusArr.push(dashbaordArr);

    if (this.hasComparatorRights) {

      mennusArr.push(CompArr);

    }
    if (this.hasAdminRights) {
      var adminArr = {
        'index': 4,
        'icon': 'fa fa-users',
        'title': 'Administration',
        'url': '#',
        'caret': 'true',
        'mode': '',
        'submenu': []
      };
      adminArr.submenu.push(
        {
          'icon': 'fa fa-users',
          'url': '/admin/user',
          'mode': '',
          'title': 'User List'
        }
      );
      adminArr.submenu.push(
        {
          'icon': 'fa fa-cloud-arrow-up',
          'url': '/admin/uploaduser',
          'mode': '',
          'title': 'Upload User'
        }
      );
      adminArr.submenu.push(
        {
          'icon': 'fa fa-cogs',
          'url': '/admin/role',
          'mode': '',
          'title': 'Roles List'
        }
      );

      adminArr.submenu.push(
        {
          'icon': 'fa fa-file-text',
          'url': '/admin/refreshdoc',
          'mode': '',
          'title': 'Re-Generate Docs'
        }
      );
      var adminRateArr = {
        'index': 5,
        'icon': 'fa fa-cogs',
        'title': 'Rate Management',
        'url': '#',
        'caret': 'true',
        'mode': '',
        'submenu': []
      };
      adminRateArr.submenu.push(
        {
          'icon': 'fa fa-cogs',
          'url': '/admin/plandesignfactor',
          'mode': '',
          'title': 'Plan Design Factor'
        }
      );
      adminRateArr.submenu.push(
        {
          'icon': 'fa fa-cogs',
          'url': '/admin/baserate',
          'mode': '',
          'title': 'Base Rate'
        }
      );

      mennusArr.push(adminArr);
      mennusArr.push(adminRateArr);

    }
    this.menus = mennusArr.sort((a, b) => a.index - b.index);

  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.menuexpandClose();
    }, 1100);
  }
  menuexpandClose() {

    var handleSidebarMenuToggle = function (menus, expandTime) {
      menus.map(function (menu) {
        menu.onclick = function (e) {
          e.preventDefault();
          var targetSubmenu = this.nextElementSibling;

          var targetItemElm = targetSubmenu.closest('.menu-item');

          if (targetItemElm.classList.contains('expand')) {
            targetItemElm.classList.remove('expand');
            targetItemElm.classList.add('closed');
          } else {
            targetItemElm.classList.add('expand');
            targetItemElm.classList.remove('closed');
          }
          slideToggle(targetSubmenu, expandTime);
        }
      });
    };

    var targetSidebar = document.querySelector('.app-sidebar:not(.app-sidebar-end)');
    var expandTime = (targetSidebar && targetSidebar.getAttribute('data-disable-slide-animation')) ? 0 : 300;
    var disableAutoCollapse = (targetSidebar && targetSidebar.getAttribute('data-disable-auto-collapse')) ? 1 : 0;

    var menuBaseSelector = '.app-sidebar .menu > .menu-item.has-sub';
    var submenuBaseSelector = ' > .menu-submenu > .menu-item.has-sub';

    // menu
    var menuLinkSelector = menuBaseSelector + ' > .menu-link';
    var menus = [].slice.call(document.querySelectorAll(menuLinkSelector));
    handleSidebarMenuToggle(menus, expandTime);

    // submenu lvl 1
    var submenuLvl1Selector = menuBaseSelector + submenuBaseSelector;
    var submenusLvl1 = [].slice.call(document.querySelectorAll(submenuLvl1Selector + ' > .menu-link'));
    handleSidebarMenuToggle(submenusLvl1, expandTime);

    // // submenu lvl 2
    // var submenuLvl2Selector = menuBaseSelector + submenuBaseSelector + submenuBaseSelector;
    // var submenusLvl2 = [].slice.call(document.querySelectorAll(submenuLvl2Selector + ' > .menu-link'));
    // handleSidebarMenuToggle(submenusLvl2, expandTime);

    menus.map(function (m) {
      var menuItemTarget = m.closest('.menu-item');
      menuItemTarget.classList.add('expand');
      menuItemTarget.querySelector(".menu-submenu").style.display = 'block';
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe(); // Prevent memory leaks
    }
    if (this.menuUpdateSubscription) {
      this.menuUpdateSubscription.unsubscribe();
    }
  }
  get hasHealthApprovalRights() {
    return this.acountService.userHasPermission(Permission.approveQuotation, AppService.Health);
  }
  get hasLifeApprovalRights() {
    return this.acountService.userHasPermission(Permission.approveQuotation, AppService.Life);
  }
  get hasAdminRights() {
    return this.acountService.userHasPermission(Permission.IsSuperAdmin);
  }
  get hasComparatorRights() {
    return this.acountService.userHasPermission(Permission.viewComparatorUI, AppService.Life);
  }
  get hasHealthIndividualQuotationRights() {
    return this.acountService.userHasPermission(Permission.individualQuotation) && this.authService.hasIndProductAccess;
  }
  get hasGroupQuotationRights() {
    return this.acountService.userHasPermission(Permission.groupQuotation);
  }
}
